import { useQuery } from "react-query";

import { fetchTypeLogData } from "api/data";

// Shape returned by the `/typeLog` endpoint after the id/value projection
// TypeLogWellSelector.tsx expects — preserved verbatim from the mapping that
// previously lived inline in useTypeLogData.tsx's mount-only `useEffect`.
// NOTE: intentionally not used as an explicit annotation on
// `fetchTypeLogWells`/`useQuery` below — `fetchTypeLogData()` has no declared
// return type (its body resolves to `any`), and the old code relied on that
// `any` propagating through the `.map()` projection so the untyped result
// could flow into `useMapStore`'s `setTypeLogWells` (`ISelectedWell[]`)
// without a structural-type error. Annotating this function's return type
// would turn that `any` into a concrete, incompatible type and introduce a
// new tsc error at that call site.
export interface TypeLogWellOption {
  id: string;
  value: string;
}

export async function fetchTypeLogWells() {
  const result = await fetchTypeLogData();
  return result?.map((item) => ({
    id: item?.uniqueId,
    value: item?.formattedId
  }));
}

export function useTypeLogWellsQuery() {
  const { data, isLoading, isError, error } = useQuery(
    ["typeLogWells"],
    fetchTypeLogWells,
    // retry: false matches the old one-shot fetchTypeLogData() call, which
    // never auto-retried (see useWellDetailGroupQuery.ts).
    { retry: false }
  );

  return { data, isLoading, isError, error };
}
